namespace Portico.Models.Enterprise {

    export interface IDocument {
        id: number;
		groupId: number;
		status: string;
		layoutCode: string;
		intakeLayoutId: number;
		typeId: number;
		source: string;
		fileName: string;
		location: string;
		isPrimary: boolean;
		createdBy: number;
		createDate: Date;
		lastUpdatedBy: number;
		lastUpdateDate: Date;
		numberOfPages: number;
	}

    export class Document implements IDocument {
		id: number;
		groupId: number;
		status: string;
		layoutCode: string;
		intakeLayoutId: number;
		typeId: number;
		source: string;
		fileName: string;
		location: string;
		isPrimary: boolean;
		createdBy: number;
		createDate: Date;
		lastUpdatedBy: number;
		lastUpdateDate: Date;
		numberOfPages: number;

        constructor(obj?: IDocument | any) {
			this.id = null;
			this.groupId = null;
			this.status = '';
			this.layoutCode = '';
			this.intakeLayoutId = null;
			this.typeId = null;
			this.source = '';
			this.fileName = '';
			this.location = '';
			this.isPrimary = false;
			this.createdBy = null;
			this.createDate = null;
			this.lastUpdatedBy = null;
			this.lastUpdateDate = null;
			this.numberOfPages = null;

            if (obj) {
				this.id = obj.id || obj.DocumentId || null;
				this.groupId = obj.groupId || obj.DocumentGroupId || null;
				this.status = obj.status || obj.DocumentStatus || '';
				this.layoutCode = obj.layoutCode || obj.DocumentLayoutCode || '';
				this.intakeLayoutId = obj.intakeLayoutId || obj.IntakeLayoutId || null;
				this.typeId = obj.typeId || obj.DocumentTypeId || null;
				this.source = obj.source || obj.DocumentSource || '';
				this.fileName = obj.fileName || obj.DocumentFileName || '';
				this.location = obj.location || obj.DocumentLocation || '';
				this.isPrimary = obj.isPrimary || obj.IsPrimary || false;
				this.createdBy = obj.createdBy || obj.CreatedBy || null;
				this.createDate = obj.createDate || obj.CreateDate || null;
				this.lastUpdatedBy = obj.lastUpdatedBy || obj.LastUpdatedBy || null;
				this.lastUpdateDate = obj.lastUpdateDate || obj.LastUpdateDate || null;
				this.numberOfPages = obj.numberOfPages || obj.NumberOfPages || null;
			}
        }
    }
}
